import { render, staticRenderFns } from "./judicialCertificate.vue?vue&type=template&id=7c5ae13f"
import script from "./judicialCertificate.vue?vue&type=script&lang=js"
export * from "./judicialCertificate.vue?vue&type=script&lang=js"
import style0 from "./judicialCertificate.vue?vue&type=style&index=0&id=7c5ae13f&prod&lang=scss&scope=true"


/* normalize component */
import normalizer from "!../../../../../../node_modules/_vue-loader@15.11.1@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports